import { consola } from 'consola'
import { onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useModalStore , modalStateEnum } from '@shared/model';
import { setAuthEntryPoint } from '@shared/lib';
import { useInstitutionStore } from '@entities/institution';
import { useAuthStore } from '~/features/auth';

import { useRuntimeConfig } from '#imports';

export function useDeepLinkRedirect() {
  const _config = useRuntimeConfig();
  const ENABLE_LOGS = true;
  const log = (...args: any[]) => ENABLE_LOGS && consola.debug('[DeepLinkRedirect]', ...args);
  const warn = (...args: any[]) => ENABLE_LOGS && consola.warn('[DeepLinkRedirect]', ...args);

  const route = useRoute();
  const storeAuth = useAuthStore();
  const storeModal = useModalStore();
  const storeInstitution = useInstitutionStore();

  // смотрим, пришли ли мы с параметром авторизации из приложения
  const isAppLogin = route.query.app_login === 'true' || route.query.state === 'app';
  log('isAppLogin:', isAppLogin);

  // формирует и открывает глубокую ссылку
  const openNativeApp = () => {
    const access = storeAuth.authAccessToken;
    const refresh = storeAuth.authRefreshToken;

    if (!access || !refresh) {
      warn('Нет токенов для передачи в приложение');
      return;
    }

    const scheme = storeInstitution.institution.legal_information_scheme;
    const host = 'auth-callback';
    const params = new URLSearchParams({
      access_token: access,
      refresh_token: refresh,
    }).toString();

    const redirectUrl = `${scheme}://${host}?${params}`;
    log('Redirecting to native app with URL:', redirectUrl);
    window.location.href = redirectUrl;
  };

  onMounted(() => {
    if (!isAppLogin) {
      log('Not an app login — skipping deep link redirect logic');
      return;
    }

    log('App login detected, checking tokens...');

    // 1) Если уже есть токены — сразу редиректим
    if (storeAuth.authAccessToken && storeAuth.authRefreshToken) {
      log('Tokens already present, redirecting to native app');
      openNativeApp();
      return;
    }

    // 2) Токенов нет — открываем модалку логина
    log('No tokens yet — opening login modal');
    setAuthEntryPoint('app_login');
    storeModal.open(modalStateEnum.Login);

    // 3) Ждём появления токенов
    watch(
      () => storeAuth.authAccessToken,
      () => {
        log('Detected authAccessToken change, waiting 1s before checking both tokens');
        setTimeout(() => {
          if (storeAuth.authAccessToken && storeAuth.authRefreshToken) {
            log('Tokens received after login, redirecting to native app');
            openNativeApp();
          } else {
            warn('Still missing tokens after login');
          }
        }, 1000);
      },
    );
  });

  return { openNativeApp, isAppLogin };
}

